module.exports = __webpack_public_path__ + "static/media/mexico.df568fd5.png";